/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Availability = {
    OneDayPerWeek: 'ONE_DAY_PER_WEEK',
    TwoDaysPerWeek: 'TWO_DAYS_PER_WEEK',
    ThreeDaysPerWeek: 'THREE_DAYS_PER_WEEK',
    FourDaysPerWeek: 'FOUR_DAYS_PER_WEEK',
    FullTime: 'FULL_TIME'
} as const;
export type Availability = typeof Availability[keyof typeof Availability];


export function instanceOfAvailability(value: any): boolean {
    for (const key in Availability) {
        if (Object.prototype.hasOwnProperty.call(Availability, key)) {
            // @ts-ignore
            if (Availability[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AvailabilityFromJSON(json: any): Availability {
    return AvailabilityFromJSONTyped(json, false);
}

export function AvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): Availability {
    return json as Availability;
}

export function AvailabilityToJSON(value?: Availability | null): any {
    return value as any;
}

